import { isPromise } from 'common/util';
import { API_ERROR } from '../const';
export default store => next => action => {
    if (!isPromise(action.payload)) {
        return next(action);
    }

    return next(action).catch(details => {
        store.dispatch({
            type: API_ERROR,
            details
        });
        if (process.env.NODE_ENV === 'development') {
            console.warn(
                action.type,
                'caught at middleware with reason',
                details
            );
        }

        return details;
    });
};
